module.exports = {
	config: {
		roleOptionScope: 'mblx',
	},

	model: {
		entityTable: false
	},

	events: {
		action: {
			type: 'click',
			selector: 'section.top button',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var $target = $(event.target);
				if($target.length > 0){
					var fieldType = $target.data('fieldType');
					if(self.model.entityTable){
						if(fieldType === 'refresh'){
							self.model.entityTable.refreshData()
						} else if(fieldType === 'showInsert'){
							self.model.entityTable.showInsert()
						}
					}
				}
			}
		}
	},

	methods: {
		toggleRowSelection: function(rowID, rowData){
			this.triggerFind('toggleRowSelection', {
				rowID,
				rowData
			});
		}
	},

	hooks: {
		attach: function($element, options){
			var self = this;
			if(!self.model.entityTable){
				self.find('base_tableSimple_table', function(entityTable){
					self.model.entityTable = entityTable;
				});
			}
		},

		filtersChanged: function($element, options){
			this.triggerFind('filtersChanged', options);
		},

		colTagsBubbleSelected: function($element, options){
			this.triggerFind('colTagsBubbleSelected', options);
		},
	}
};
